import React from "react";
import HeaderSubMenuItem from "./HeaderSubMenuItem";

const HeaderSubMenu = (props) => {
    const {subMenuItems, touch} = props;
    return (
        <div className={`absolute right-0 top-1vh z-50 w-[200px] pt-[10px] ${touch ? 'block' : "hidden"} group-hover:block`}>
           <div className="bg-white border border-[#e0e0e0] z-[99999] p-[8px] rounded-[8px] space-y-[8px]">
                {subMenuItems.map((item, index) => (
                    <HeaderSubMenuItem
                        key={index}
                        icon={item.icon}
                        menu={item.menu} 
                        link={item.link} 
                        number={item.number || ''} 
                    />
                ))}
           </div>
        </div>
    );
}

export default HeaderSubMenu;